module.exports = __webpack_public_path__ + "img/active-cover.0f1d62a0.png";